var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "container-fluid landing-container" }, [
      _c("div", { staticClass: "dashboard-block" }, [
        _c("h1", { staticClass: "text-center" }, [
          _vm._v("Congratulations, " + _vm._s(_vm.$user.first_name) + "!"),
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "decorative-divider" }),
        _vm._v(" "),
        _c("h2", { staticClass: "text-center subheading-text" }, [
          _vm._v("What's next?"),
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "icon-list" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "row display-table" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Then your request will be put to our sports " +
                    _vm._s(_vm.$starLabel) +
                    " network."
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "row display-table" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "You will start to see " +
                    _vm._s(_vm.$starLabelPlural) +
                    " applying almost immediately."
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "button-wrapper" },
          [
            _c(
              "router-link",
              {
                attrs: {
                  to: {
                    name: "requests.show",
                    params: { id: this.$route.params.id },
                  },
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-block btn-primary dropdown-toggle",
                    attrs: { type: "button" },
                  },
                  [_vm._v("\n            Review Request\n          ")]
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12 text-center tick" }, [
      _c("div", { staticClass: "fa-stack fa-5x" }, [
        _c("i", {
          staticClass: "fa fa-circle fa-stack-2x icon-background-success",
        }),
        _vm._v(" "),
        _c("i", { staticClass: "fa fa-check fa-stack-1x icon-foreground" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("div", { staticClass: "row display-table" }, [
        _c("div", { staticClass: "fa-stack fa-3x display-table" }, [
          _c("i", {
            staticClass: "fa fa-circle fa-stack-2x icon-background-primary",
          }),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-phone fa-stack-1x icon-foreground" }),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Our team will be in contact shortly to finalise any details."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "fa-stack fa-3x display-table" }, [
      _c("i", {
        staticClass: "fa fa-circle fa-stack-2x icon-background-primary",
      }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-share-alt fa-stack-1x icon-foreground" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "fa-stack fa-3x display-table" }, [
      _c("i", {
        staticClass: "fa fa-circle fa-stack-2x icon-background-primary",
      }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-check fa-stack-1x icon-foreground" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }